let oldBoostContainer;

export function initBoostUI() {
    // Hide the old horizontal boost container
    oldBoostContainer = document.getElementById('boost-container');
    if (oldBoostContainer) {
        oldBoostContainer.style.display = 'none';
    }
}

export function updateBoostUI() {
    // No visual gauge to update
}
